module.exports = __webpack_public_path__ + "img/bg-what-we-do.14f5622c.jpg";